import { render, staticRenderFns } from "./ViewPropertiesPaymentComponent.vue?vue&type=template&id=ebcf45a8"
import script from "./ViewPropertiesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./ViewPropertiesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports